import styled from "styled-components";

export const Feedbacks = styled.section`
  height: 500px;
  background-color: #eefdffff;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 1100px;
  }

  .feedbacks {
    margin-top: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 30px;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      row-gap: 50px;
    }
    .feedback_container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 90%;
    }
    .feedback {
      width: 30%;
      background-color: white;
      padding: 20px;
      padding-right: 20px;
      box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
      position: relative;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 30px;
      }
      i {
        position: absolute;
        top: -18px;
        width: 35px;
        height: 35px;
        background-color: ${({ theme }) => theme.color.red};
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
      .context_feedback {
        font-size: 12px;
        font-weight: 400;
        p {
          line-height: 1.5;
          @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            font-size: 1rem;
            opacity: 0.7;
          }
        }
        .profile {
          margin-top: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .title {
            line-height: 1.7;
            h2 {
              font-weight: 500;
            }
          }
          .customer {
            background-color: gray;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 15px;
          }
        }
      }
    }
  }
`;
